import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import RenderCode from './renderCode';

const Form = ({ onSubmit }) => {
  const { t } = useTranslation('deliveries');
  const { handleSubmit, formState: { isSubmitting, errors } } = useFormContext();

  return (
    <form className="auth-form" onSubmit={handleSubmit(onSubmit)}>
      <h3>{t('authenticate.form.header')}</h3>
      <div className="auth-form-inner">
        <span className="auth-sub-header">{t('authenticate.form.subHeader')}</span>
        <RenderCode length={6} />
        <button
          type="submit"
          className="btn btn--primary btn--block"
          disabled={isSubmitting}
        >
          {t('authenticate.form.button')}
        </button>
        {errors.root && (
          <span className="help-text help-text--has-error">{errors.root.message}</span>
        )}
      </div>
    </form>
  );
};

export default Form;